if (!customElements.get('product-discovery')) {
  class ProductDiscovery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-product-discovery-track]');
      this.previous = this.querySelector('[data-product-discovery-previous]');
      this.next = this.querySelector('[data-product-discovery-next]');
      if (!this.track) return;

      this.abortController = new AbortController();
      this.previous?.addEventListener('click', () => this.scroll(-1), { signal: this.abortController.signal });
      this.next?.addEventListener('click', () => this.scroll(1), { signal: this.abortController.signal });
      this.track.addEventListener('scroll', () => this.update(), {
        passive: true,
        signal: this.abortController.signal,
      });
      window.addEventListener('resize', () => this.update(), { signal: this.abortController.signal });
      this.update();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    scroll(direction) {
      const item = this.track.querySelector('li');
      if (!item) return;
      const styles = getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      this.track.scrollBy({ left: (item.getBoundingClientRect().width + gap) * direction, behavior: 'smooth' });
    }

    update() {
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const hasOverflow = maxScroll > 2;
      if (this.previous) this.previous.hidden = !hasOverflow || this.track.scrollLeft <= 2;
      if (this.next) this.next.hidden = !hasOverflow || this.track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('product-discovery', ProductDiscovery);
}
